import { checkKey, removeKey, updateEncounter } from 'Store/encounters'

import config from 'Config'
import { toast } from 'react-toastify'

let retries = 0

const downloadReport = ({ msg }) => {
  const { key } = msg
  if (!checkKey({ key })) return
  toast.info('Your download is complete.')
  removeKey({ key })

  window.open(`${config.api.getUrl()}/report/download?key=${key}`, '_blank')
}

const WebsocketService = {
  async connect() {
    const ws = new WebSocket(config.ws.getUrl())

    /* 
    NOTE: For on open and on error added special logging. 
   */

    ws.onopen = () => {}
    ws.onerror = err => {
      console.error(err)
    }

    ws.onmessage = msg => {
      this.parseMessage(msg, ws)
    }

    ws.onclose = event => {
      if (event.code !== 1005) {
        setTimeout(() => {
          if (retries <= 5) {
            ws.close()
            this.connect()
            retries += 1
          }
        }, 2 * 1000)
      }
    }

    return ws
  },
  async heartbeat(ws) {
    if (ws.readyState !== 1) return
    ws.send('heartbeat')
    setInterval(() => this.heartbeat(ws), 15 * 1000)
  },
  async parseMessage(msg, ws) {
    const { type, description } = JSON.parse(msg.data)
    switch (type) {
      case 'ENCOUNTER_UPDATE':
        updateEncounter(description.id, description.operationType)
        break
      case 'REPORT_FINISH':
        downloadReport({ msg: JSON.parse(msg.data) })
        break
      case 'HEARTBEAT':
        // eslint-disable-next-line no-console
        console.log('Heartbeat')
        ws.send(JSON.stringify({ type: 'HEARTBEAT' }))
        break
      default:
        break
    }
  }
}

export default WebsocketService
